<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.title.$anyError
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />

                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.note.$anyError
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Note
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        rows="5"
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Note"
                        v-model="note"
                      ></textarea>
                      <form-error
                        :model="$v.note"
                        :dirty="$v.$dirty"
                        label="Note"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.userId.$anyError
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Korisnik</label>
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ 'has-danger': $v.userId.$anyError }" v-if="dataInitialized">
                        <treeselect
                          v-model="userId"
                          loadingText="Učitavanje..."
                          noResultsText="Nema rezultata"
                          searchPromptText="Pretraga"
                          :load-options="loadUsers"
                          :async="true"
                          :options="users"
                          :default-options="users"
                          placeholder="Pretraga"
                        />
                      </div>
                      <form-error
                        :model="$v.userId"
                        :dirty="$v.$dirty"
                        label="Korisnik"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.categoryIds.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.category }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ 'has-danger': $v.categoryIds.$anyError }">
                        <treeselect
                          v-model="categoryIds"
                          :multiple="true"
                          :options="categoriesTreeView"
                          :show-count="true"
                          placeholder="Izaberite kategoriju"
                          value-consists-of="ALL"
                          v-if="categoriesTreeView"
                        />
                      </div>
                      <form-error
                        :model="$v.categoryIds"
                        :dirty="$v.$dirty"
                        :label="translations.forms.labels.category"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            class="
              cancel-button
              btn btn-light btn-px-4
              py-3
              border
              font-weight-semibold
              text-color-dark text-3
            "
            exact
            :to="{ name: 'ServiceManagers' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              ubmit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddServiceManager',
  mixins: [translations],
  validations,
  components: {
    Treeselect,
    FormError,
  },
  data() {
    return {
      title: '',
      note: '',
      userId: null,
      categoryIds: [],
      dataInitialized: false,
    };
  },
  computed: {
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    categoriesTreeView() {
      return this.$store.getters.getCategoriesTree;
    },
    users() {
      return this.$store.getters.getUsers.map((item) => {
        return {
          id: item.id,
          label: `${item.firstName} ${item.lastName}`,
        };
      });
    },
  },
  methods: {
    loadUsers({ callback, searchQuery }) {
      this.$store
        .dispatch("getUsers", {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: "firstName",
        })
        .then(() => {
          callback(null, this.users);
        });
    },
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const {
        title,
        note,
        userId,
        categoryIds,
      } = this;

      api.createServiceManager({
        title,
        note,
        userId,
        categoryIds,
      })
      .then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'ServiceManagers' });
      })
      .catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
  mounted() {
    this.$store.dispatch('getSimplifiedCategories', {});
    this.$store.dispatch('getUsers', {
      companyId: this.loggedUser.companyId,
      isSortAscending: true,
      retrieveAll: true,
      sortBy: "firstName",
    }).then(() => {
      this.dataInitialized = true;
    });
  },
};
</script>
